module.exports = __webpack_public_path__ + "img/9.ede08aff.png";